import { useEffect, useState } from "react";
import arrowRight from "../../assets/icons/arrow-right.svg";
import { Link } from "react-router-dom";
import { listNews } from "../../services/newsService";
import { format } from "date-fns";
import { toast } from "react-toastify";

const News = () => {
  const [activeDots, setActiveDots] = useState(0);
  const [news, setNews] = useState([]);
  const [page, setPage] = useState(1);
  const [isFetching, setIsFetching] = useState(true);

  const headers = {
    "Content-Type": "application/json",
  };

  useEffect(() => {
    fetchNews({
      page: page - 1,
      size: 12,
    });
    // eslint-disable-next-line
  }, [isFetching]);

  const fetchNews = async (params) => {
    listNews(headers, params)
      .then((res) => {
        if (res?.data) {
          setNews(res?.data);
          setIsFetching(false);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), "dd-MM-yyyy");
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="news-page">
      <section className="news-section">
        <div className="news-content">
          <h2 className="news-title">Blog Blue-zone</h2>
          <p className="news-description">
            Tổng hợp kiến thức tài chính, hướng dẫn vay vốn và các thông tin hữu
            ích từ Blue-zone
          </p>

          {/* <div className="row news-grid">
            {news?.content?.map((tintuc) => (
              <div className="col-12 col-md-6 col-lg-4 justify-content-center">
                <div className="news-box">
                  <div className="box-img">
                    <img
                      src={tintuc?.imageNews}
                      alt="news"
                      className="img-news"
                    />
                  </div>
                  <div className="box-content">
                    <div className="news-box-content">
                      <div className="news-time">
                        {formatDate(tintuc?.createdDate)}
                      </div>
                      <h3 className="news-heading">
                        {tintuc?.title.length > 65
                          ? tintuc.title.substring(0, 65) + "..."
                          : tintuc.title}
                      </h3>
                      <p className="news-desc">
                        {tintuc?.description.length > 85
                          ? tintuc.description.substring(0, 85) + "..."
                          : tintuc.description}
                      </p>
                    </div>
                    <div className="box-redmore">
                      <div className="news-readmore">
                        <div className="news-actions">
                          <Link
                            to={tintuc?.url}
                            className="news-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Đọc tiếp <img src={arrowRight} alt="arrow right" />
                          </Link>
                          <span className="news-source">
                            Nguồn: {tintuc?.sourceNews}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {news?.totalElements > 8 && (
            <div className="pagination">
              {Array.from({ length: news?.totalPages || 1 }).map((_, index) => (
                <div
                  key={index}
                  className={`dot ${activeDots === index ? "active" : ""}`}
                  onClick={() => {
                    setActiveDots(index);
                    setPage(index + 1);
                  }}
                ></div>
              ))}
            </div>
          )} */}
        </div>
      </section>
    </div>
  );
};

export default News;
